module.exports = __webpack_public_path__ + "img/bell.e838b862.svg";